import { useState, useEffect } from "react";
import { loadWarehouseDataReportList, RefreshDataReportList, loadProductionReportListByDateRange } from "../../services/warehouseService";


const useWarehouseDataReport = () => {
    const [warehouseDataReportList, setWarehouseDataReportList] = useState([]);
    const [isWarehouseDataLoaded, setIsWarehouseDataLoaded] = useState(false);
    const [loading, setLoading] = useState(false);

    // Fetch department data
    const fetchWarehouseList = async (selectedID = null) => {
        try {

            let data;
            // const para = {
            //     p_company_id: localStorage.getItem("companyid"),
            //     p_plant_id: 1,

            // };
            const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

            const para = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
                p_filter_type: "all",
                p_from_date: today,
                p_to_date: today,
            };


            setLoading(true);
            // data = await loadWarehouseDataReportList(para);
            data = await loadProductionReportListByDateRange(para);
            if (data && data.length > 0) {
                setWarehouseDataReportList(data);
                setLoading(false);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
            setLoading(false);
        }
    };


    const RefreshData = async () => {
        setLoading(true);
        try {
            const para = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
            };

            // Refresh materialized data and then load report data
            await RefreshDataReportList(para);
            const newData = await loadWarehouseDataReportList(para);

            if (Array.isArray(newData) && newData.length > 0) {
                setWarehouseDataReportList(newData);
            }
        } catch (error) {
            console.error("Error refreshing data:", error);
            // CallMessage("error", error.message, "Error");
        } finally {
            setLoading(false);
        }
    };

    const FilterProductionData = async (company_id, plant_id, filter_id, from_date, to_date) => {
        setLoading(true);
        try {
            const para = {
                p_company_id: localStorage.getItem("companyid"),
                p_plant_id: 1,
            };

            const payload = {
                p_company_id: company_id,
                p_plant_id: plant_id,
                p_filter_type: filter_id,
                p_from_date: from_date,
                p_to_date: to_date,
            };

            // Refresh materialized data and then load report data
            await RefreshDataReportList(para);
            const newData = await loadProductionReportListByDateRange(payload);

            if (Array.isArray(newData) && newData.length > 0) {
                setWarehouseDataReportList(newData);
            }
            else {
                setWarehouseDataReportList([]);
            }
        } catch (error) {
            console.error("Error refreshing data:", error);
            // CallMessage("error", error.message, "Error");
        } finally {
            setLoading(false);
        }
    }


    // Load departments when the component mounts
    useEffect(() => {
        if (!isWarehouseDataLoaded) {
            fetchWarehouseList();
        }
    }, [isWarehouseDataLoaded]);

    // Function to load department based on selected ID
    const loadWarehouseByID = async (selectedID) => {
        await fetchWarehouseList(selectedID);
    };

    return {
        warehouseDataReportList,
        setWarehouseDataReportList,
        loadWarehouseByID,
        loading, setLoading,
        RefreshData,
        FilterProductionData
    };
};

export default useWarehouseDataReport;
